var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col min-h-screen bg-slate-50 text-slate-900 font-sans",attrs:{"id":"app"}},[_c('router-view'),_c('WhatsAppFloat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }